export const MAX_NOTE_LENGTH = 2000;

export default MAX_NOTE_LENGTH;
